import config from '@/lib/config';
import dayjs from '@/lib/helpers/date';

type PlanTier = 'standard' | 'plus' | 'vip' | 'ultim';

export const plans = [
  {
    id: 'standard' as PlanTier,
    name: 'Standard',
    monthly: {
      discountedPrice: 0,
      price: 0,
      stripePlan: null,
    },
    annual: {
      discountedPrice: 0,
      price: 0,
      stripePlan: null,
    },
    color: 'bg-gray-100',
    textColor: 'text-gray-900',
    highlighted: false,
    visibleOnlyForNonPaying: true,
  },
  {
    id: 'plus' as PlanTier,
    name: 'Plus',
    monthly: {
      discountedPrice: 29,
      price: 59,
      stripePlan: 'plus_monthly_59',
    },
    annual: {
      discountedPrice: 299,
      price: 599,
      stripePlan: 'plus_yearly_599',
    },
    color: 'bg-starter/10',
    textColor: 'text-starter',
    highlighted: false,
    visibleOnlyForNonPaying: false,
  },
  {
    id: 'vip' as PlanTier,
    name: 'VIP',
    monthly: {
      discountedPrice: 59,
      price: 139,
      stripePlan: 'vip_monthly_139',
    },
    annual: {
      discountedPrice: 599,
      price: 1399,
      stripePlan: 'vip_yearly_1399',
    },
    color: 'bg-primary/10',
    textColor: 'text-primary',
    highlighted: true,
    badge: 'Recommandé',
    visibleOnlyForNonPaying: false,
  },
  {
    id: 'ultim' as PlanTier,
    name: 'Ultim',
    monthly: {
      discountedPrice: 139,
      price: 329,
      stripePlan: 'ultim_monthly_329',
    },
    annual: {
      discountedPrice: 1399,
      price: 3299,
      stripePlan: 'ultim_yearly_3299',
    },
    color: 'bg-accent/10',
    textColor: 'text-accent',
    highlighted: false,
    visibleOnlyForNonPaying: false,
  },
];

export const getPlanPrice = (planId: PlanTier, period: 'monthly' | 'annual' = 'monthly', useSpecialOffer: boolean = false) => {
  const plan = plans.find((p) => p.id === planId);
  if (!plan) return 0;

  const pricing = plan[period];
  return useSpecialOffer ? pricing.discountedPrice : pricing.price;
};

export const isSpecialOfferActive = () => {
  return dayjs().isBefore(dayjs(config.specialOfferForHistoricMembers.endAt));
};

export const getCurrentPrice = (planId: PlanTier, period: 'monthly' | 'annual' = 'monthly') => {
  return getPlanPrice(planId, period, isSpecialOfferActive());
};
